import { Injectable } from '@angular/core';
import CryptoES from 'crypto-es';
import { CypherGateway } from '@domain/models/cypher/gateway/cypher.gateway';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CypherService extends CypherGateway {
  private _cipherPassphrase = CryptoES.enc.Hex.parse(environment.cipherPassphrase);
  private _cipherOptions = {
    keySize: 128 / 8,
    iv: this._cipherPassphrase,
    mode: CryptoES.mode.CBC,
    padding: CryptoES.pad.Pkcs7,
  };

  constructor() {
    super();
  }

  encryptText(text: string): string {
    return CryptoES.AES.encrypt(CryptoES.enc.Utf8.parse(text), this._cipherPassphrase, this._cipherOptions).toString();
  }

  decryptText(text: string): string {
    return CryptoES.AES.decrypt(text, this._cipherPassphrase, this._cipherOptions).toString(CryptoES.enc.Utf8);
  }

  encryptObject(object: Object): string {
    return CryptoES.AES.encrypt(JSON.stringify(object), this._cipherPassphrase, this._cipherOptions).toString();
  }

  decryptObject(hash: string): any {
    if (hash?.length) {
      let object = CryptoES.enc.Utf8.stringify(CryptoES.AES.decrypt(hash, this._cipherPassphrase, this._cipherOptions));
      if (object.length) {
        return JSON.parse(object);
      }
    }
    return null;
  }
}
